import { getConfig } from "../config";
function getDisableSSR(componentContext) {
  return componentContext?.disableSSR ?? getConfig().disableSSR;
}
export {
  getDisableSSR
};
//# sourceMappingURL=useDisableSSR.js.map
